<template>
  <div
    ref="heroSection"
    class="tw:bg-green-200 tw:pt-[40px] tw:md:pt-[60px] tw:relative"
    :class="
      !isLoading && listOfEligibleAccommodations.length > 0
        ? 'tw:min-h-[484px]'
        : 'tw:min-h-[484px] tw:md:min-h-[448px] tw:lg:min-h-[484px]'
    "
  >
    <ContainerLayout class="tw:h-full tw:flex tw:flex-col tw:md:flex-row tw:gap-y-10 tw:xl:px-12">
      <div
        class="tw:w-full tw:md:w-3/5 tw:lg:w-1/2 tw:flex tw:flex-col tw:gap-[40px] tw:md:gap-y-12 tw:lg:gap-y-[70px] tw:md:mr-16 tw:lg:mr-auto"
      >
        <div class="tw:flex tw:flex-col tw:gap-y-4">
          <h1
            class="tw:text-[32px] tw:lg:text-[44px] tw:leading-[40px] tw:lg:leading-[55px]"
            data-testid="rc-blocked-country-header"
            v-html="$t('rc_country_ineligible_header')"
          />
          <p
            class="tw:text-xl tw:leading-[25px]"
            data-testid="rc-blocked-country-ineligible-subtext"
            v-html="
              !isLoading && listOfEligibleAccommodations.length > 0
                ? $t('rc_property_ineligible_subtext')
                : $t('rc_country_ineligible_subtext')
            "
          />
        </div>

        <PropertySelector
          :properties="listOfEligibleAccommodations"
          v-if="!isLoading && listOfEligibleAccommodations.length > 0"
        />
      </div>
      <div class="tw:w-full tw:md:w-2/5 tw:lg:w-1/2 tw:flex tw:items-center tw:justify-center tw:h-full">
        <img
          :src="heroImage"
          alt="Rate Connect"
          class="tw:mx-auto tw:max-h-[388px] tw:md:max-h-[431px] tw:lg:max-h-[450px] tw:w-auto tw:md:absolute tw:bottom-0"
        />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import ContainerLayout from '@/layouts/ContainerLayout.vue'
import PropertySelector from '@/components/rateConnect/notEligible/PropertySelector.vue'

import { useIsMobile } from '@/composables/useIsMobile'
import { useSessionValues } from '@/composables/useSessionValues'

defineProps({
  isLoading: Boolean,
  listOfEligibleAccommodations: Array,
})

const { screenWidth } = useIsMobile()
const screenSize = computed(() => {
  if (screenWidth.value > 1024) {
    return 'l'
  } else if (screenWidth.value > 768) {
    return 'm'
  } else {
    return 's'
  }
})
const heroImages = import.meta.glob('/src/assets/img/rate-connect/not-eligible-hero-image/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
})

const heroImage = computed(() => {
  const path = `/src/assets/img/rate-connect/not-eligible-hero-image/hero_image_${screenSize.value}_${currentLocation.value}.png`

  return heroImages[path] || ''
})

const { language } = useSessionValues()
const currentLocation = computed(() => language.value.split('-')[1].toLowerCase())
</script>
